import { API } from "../core/API";

const api = new API("/api/v1");

export const configService = {
    getAll: () => api.get("/configs"),
    create: (data) => api.put("/configs", data),
    update: (id, data) => api.put(`/configs/${id}`, data),
    delete: (id) => api.delete(`/configs/${id}`)
};
